import React, { Component } from 'react'
import cold1 from '../../images/cold1.png'
import { Link } from 'react-router-dom';

export class Card1 extends Component {
  handleClick = () => {

    this.props.navigate(this.props.to, { state: { category_id: this.props.category_id } });
  };
  render() {
    const { image, title, bg, color, btn_bg, to = '/products', category_id } = this.props;
    return (
      <div className={`flex flex-col justify-between gap-[6px] rounded-[20px] ${bg} p-[14px] hover:shadow-lg`}>
        <img src={image} className='w-full max-h-[400px]' />
        <div>
          <span className={`${color} font-[500] text-[20px] leading-[20px] text-[#000]`}>{title}</span>
        </div>
        {category_id ? (
          <Link to={{ pathname: to }}
            state={{ category_id: category_id }} className={`font-[500] text-[16px] leading-[20px] ${btn_bg} w-[130px] p-[8px_30px] rounded-[75px]`}>Daxil Ol</Link>
        ) :
          <Link to="/details" className={`font-[500] text-[16px] leading-[20px] ${btn_bg} w-[130px] p-[8px_30px] rounded-[75px]`}>
            Daxil ol
          </Link>

        }

      </div>
    )
  }
}

export default Card1